import type { Post } from "src/types/blog";
import { blog3 } from "./blog3";
import { blog4 } from "./blog4";
import { boluswizard } from "./boluswizard";
import { cgmTestPrivacy } from "./cgm-test-privacy";
import { cgmTestReliability } from "./cgm-test-reliability";
import { cgmTestUsability } from "./cgm-test-usability";
import { cloudbuilder } from "./cloudbuilder";
import { festiveDiabetesTips } from "./festive-diabetes-tips";
import { howToChooseInsulinPump } from "./how-to-choose-insulin-pump";
import { hyperglycaemiaMorning } from "./hyperglycaemia-morning";
import { nightscoutDatabaseStorage } from "./nightscout-database-storage";
import { unannouncedMealDetection } from "./unannounced-meal-detection";
import { noprofileset } from "./noprofileset";
import { proteinhiddenimpace } from "./proteinhiddenimpace";
import { sexType1Looping } from "./sex-type-1-looping";
import { ultrahuman } from "./ultrahuman";
import { whoisCorne } from "./whoiscorne";
import { whoishylke } from "./whoishylke";
import { whoiskelvin } from "./whoiskelvin";
import { whoisLukas } from "./whoislukas";
import { whoispaul } from "./whoispaul";
import { whoisredmer } from "./whoisredmer";
// removed manifesto post

export const posts: Post[] = [
  {
    id: "unannounced-meal-detection",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "OSC",
    },
    category: "General",
    cover: "/assets/blogs/unannounced-meal-thinking-40g.jpg",
    publishedAt: new Date("2026-11-04").getTime(),
    readTime: "10 min",
    shortDescription:
      "Unannounced meal detection lets some loops dose insulin without carb entries. See how UAM and SMB work, and when carbless looping is a poor fit.",
    title:
      "Diabetes Without Counting Carbs: How Unannounced Meal Detection Works",
    seoTitle: "Unannounced Meal Detection: Looping Without Counting Carbs",
    path: "/unannounced-meal-detection",
  },
  {
    id: "nightscout-database-storage",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    cover:
      "/assets/blogs/nightscout-database-storage/dashboard-database-size.png",
    publishedAt: new Date("2026-06-08").getTime(),
    readTime: "5 min",
    shortDescription: "Clean up your Nightscout database to free up space.",
    title: "How to Check and Clean Your Nightscout Database Storage",
  },
  {
    id: "sex-type-1-and-looping",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Chelsea Okonkwo and Kelvin Kramp (MD, PhD)",
    },
    category: "General",
    cover: "/assets/blogs/sex-type-1-looping-cover-photo.png",
    publishedAt: new Date("2026-10-01").getTime(),
    readTime: "16 min",
    shortDescription:
      "How type 1 diabetes can affect sexual health, and how to manage your pump, CGM, glucose, and alarms so intimacy stays safe and less stressful.",
    title: "Sex, Looping, and Type 1 Diabetes",
  },
  {
    id: "hyperglycaemia-in-the-morning",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka and Kelvin Kramp",
    },
    category: "General",
    cover:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*kyefZKhl_vok72RIKOCsLg.png",
    publishedAt: new Date("2026-03-19").getTime(),
    readTime: "6 min",
    shortDescription:
      "The Dawn Phenomenon and Somogyi effect can look similar in the morning, but they require opposite insulin strategies.",
    title: "Hyperglycaemia in the Morning - Dawn Phenomenon vs Somogyi",
  },
  {
    id: "how-to-choose-an-insulin-pump",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Insulin Pump Guide",
    cover:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*GZFncmjyoD443CTal82y4A.png",
    publishedAt: new Date("2025-01-20").getTime(),
    readTime: "11 min",
    shortDescription:
      "Questions to ask before you choose an insulin pump: loop compatibility, CGM pairing, reservoirs, and the daily tasks that matter more than the brand.",
    title: "How to Choose an Insulin Pump",
  },
  {
    id: "10-cgm-test-results-comparison",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/sensorcomparison/sensorpackaging.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "12 min",
    shortDescription:
      "An n=1 comparison of 10 continuous glucose monitoring sensors, focusing on user experience, usability, and integration capabilities for automated insulin delivery systems.",
    title: "Insights from Testing 10 CGMs - How They Stack Up in Daily Use",
  },
  {
    id: "cgm-test-reliability-accuracy",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/nscomparisonsensors.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "15 min",
    shortDescription:
      "An n=1 comparison of 10 continuous glucose monitoring sensors, focusing on reliability, accuracy, MARD trends, and detailed performance metrics.",
    title:
      "Insights from Testing 10 CGMs - A Comparison in Reliability and Accuracy",
  },
  {
    id: "cgm-privacy-data-locations",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/sensorcomparison/cloudserverdata.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "8 min",
    shortDescription:
      "A detailed look at where CGM data is stored, privacy policies, and data residency for 10 different continuous glucose monitoring systems.",
    title:
      "Where Does Your Glucose Data Really Go - A Look at CGM Privacy and Server Locations",
  },
  {
    id: "why-we-created-a-cloud-builder",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover: "/assets/blogs/GitHubActions.png",
    publishedAt: new Date("2025-12-18").getTime(),
    readTime: "5 min",
    shortDescription:
      "Automating complexity in open-source diabetes management.",
    title: "Why We Created a Cloud Builder",
  },
  {
    id: "festive-diabetes-management-tips",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "General",
    cover: "/assets/blogs/festive-diabetes-tips.png",
    publishedAt: new Date("2025-12-20").getTime(),
    readTime: "8 min",
    shortDescription:
      "Practical tips to help you navigate Christmas as smoothly as possible.",
    title: "Enjoying Christmas with Type 1 Diabetes",
  },
  {
    id: "Who-am-I-Lukas-Trcka",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Community",
    cover: "/assets/avatars/LukasTrcka.png",
    publishedAt: new Date("2025-10-14").getTime(),
    readTime: "7 min",
    shortDescription:
      "As a person with type 1 diabetes who began looping after his diagnosis, Lukáš now shares his expertise as a diabetes educator, helping others navigate the open-source looping community.",
    title: "Introducing Lukáš Trčka",
  },
  {
    id: "Who-am-I-Paul-Banks",
    author: {
      avatar: "",
      name: "Paul Banks",
    },
    category: "Community",
    cover: "/assets/avatars/paulbankspresenting.png",
    publishedAt: new Date("2026-03-16").getTime(),
    readTime: "4 min",
    shortDescription:
      "Paul brings a strategy lens to OSC in order to scale global access to open-source diabetes technology.",
    title: "Introducing Paul Banks",
    content: whoispaul,
  },
  {
    id: "Who-am-I-Corne-Gabriels",
    author: {
      avatar: "/assets/avatars/CG.png",
      name: "Corne Gabriels",
    },
    category: "Community",
    cover: "/assets/avatars/CG.png",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription:
      "As data architect and consultant with expertise in cloud technologies and data analysis with MODY diabetes, Corne understands the challenges of those entering the open-source looping community.",
    title: "Introducing Corné Gabriels",
  },
  {
    id: "Bolus-wizard-AndroidAPS-123456",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover: "/assets/blogs/boluswizard.png",
    publishedAt: new Date("2024-01-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "Tips for using the Bolus Wizard in AndroidAPS to calculate the correct bolus for your meal",
    title: "Bolus Wizard tips in AndroidAPS",
  },
  {
    id: "Who-am-I-Redmer-Nauta",
    author: {
      avatar: "/assets/avatars/RN.png",
      name: "Redmer Nauta",
    },
    category: "Community",
    cover: "/assets/avatars/RN.png",
    publishedAt: new Date("2025-04-06").getTime(),
    readTime: "5 min",
    shortDescription:
      "Redmer supports our mission to provide open-source solutions for diabetes management.",
    title: "Introducing Redmer Nauta",
  },
  {
    id: "ultrahuman-123456",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "CGM",
    cover:
      "https://cdn-images-1.medium.com/max/2000/1*sfG5i02kf8TnT_hZeA6gZQ.png",
    publishedAt: new Date("2024-01-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "Skip the Hype: Chose a More Affordable Option for Managing Your Glucose",
    title:
      "Why Ultrahuman Is Not the Best Choice for Type 1 Diabetes Management",
  },
  {
    id: "Who-am-I-Hylke-Nicola",
    author: {
      avatar: "/assets/avatars/HN.png",
      name: "Hylke Nicola",
    },
    category: "Community",
    cover: "/assets/avatars/HN.png",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription:
      "With experience as AIOPS specialist, and type 1 diabetes since 2003, Hylke brings a wide range of technical expertise and user experience to the team.",
    title: "Introducing Hylke Nicola",
  },
  {
    id: "Who-am-I-Kelvin-Kramp",
    author: {
      avatar: "/assets/avatars/KK2.png",
      name: "Kelvin Kramp",
    },
    category: "Community",
    cover: "/assets/avatars/KK2.png",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription:
      "With 4 years of experience as healthcare engineer and type 1 diabetes since 2005, Kelvin is passionate about making open-source diabetes care more accessible.",
    title: "Introducing Kelvin Kramp",
  },
  {
    id: "24b76cac9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    cover: "/assets/covers/business-2-4x4-large.png",
    publishedAt: new Date("2024-06-10").getTime(),
    readTime: "5 min",
    shortDescription:
      "Follow these steps to ensure your site is safely locked and accessible only to authorized healthcare professionals, care-takers and family members.",
    title: "How to Create a Reading Access URL to Your Nightscout",
  },
  // {
  //   id: "00b76cac9a128cd949741010",
  //   author: {
  //     avatar: "/assets/avatars/kelvinkramp.png",
  //     name: "Kelvin Kramp",
  //   },
  //   category: "CGM",
  //   cover: "/assets/blogs/1_RTPQ2wuRy4lrMesyrEEKOA.png",
  //   publishedAt: new Date("2021-05-15").getTime(),
  //   readTime: "30 min",
  //   shortDescription:
  //     "A step-by-step instructions to help you monitor your glucose levels in real-time with a Freestyle Libre 2",
  //   title: "Setup Your FreeStyle Libre 2 As A Continuous Glucose Monitor",
  // },
  // {
  //   id: "00111cac9a128cd949741010",
  //   author: {
  //     avatar: "/assets/avatars/kelvinkramp.png",
  //     name: "Kelvin Kramp",
  //   },
  //   category: "Research",
  //   cover: "/assets/blogs/whitepaper.png",
  //   publishedAt: new Date("2024-05-21").getTime(),
  //   readTime: "15 min",
  //   shortDescription:
  //     "Universal access to advanced, user-friendly open sourcer diabetes management technology through collaborative open-source development involving PWD, healthcare professionals, and IT experts, to overcome existing economic, geographical, and educational barriers.",
  //   title: "Opensource.clinic White Paper",
  // },
  {
    id: "11b76cac9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    cover: "/assets/blogs/switchNSblog.png",
    publishedAt: new Date("2024-06-10").getTime(),
    readTime: "5 min",
    shortDescription:
      "Considering switching your Nightscout provider? Here's how to do it",
    title:
      "How to Switch Your Nightscout URL to a New Hosting Provider When Looping with AndroidAPS and xDrip",
  },
  // {
  //   id: "Lyumjev-pump-guide-123456",
  //   author: {
  //     avatar: "/assets/avatars/kelvinkramp.png",
  //     name: "Kelvin Kramp",
  //   },
  //   category: "Insulin Pump Guide",
  //   cover: "/assets/blogs/Lyumjev.png",
  //   publishedAt: new Date("2024-06-10").getTime(),
  //   readTime: "5 min",
  //   shortDescription:
  //     "Learn how to  fill your insulin pump cartridge with Lyumjev",
  //   title: "How to Fill Your Insulin Pump Cartridge with Lyumjev",
  // },
  {
    id: "protein-hidden-impact-123456",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Research",
    cover: "/assets/blogs/proteinimpact.png",
    publishedAt: new Date("2024-03-21").getTime(),
    readTime: "15 min",
    shortDescription:
      "How protein raises glucose later than carbohydrates, and what that means for boluses and open-source loop settings.",
    title: "Protein's Hidden Impact on Blood Glucose",
  },
  {
    id: "no-profile-set-error-fix",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover:
      "https://cdn-images-1.medium.com/max/2000/1*fx0ygQ2-mYWAkBvTjHrBgA.png",
    publishedAt: new Date("2024-03-20").getTime(),
    readTime: "3 min",
    shortDescription:
      'A guide to resolving the common "No Profile Set" error in AndroidAPS after updates.',
    title: "How to Fix the No Profile Set Error in AndroidAPS",
  },
  // removed manifesto from teaser posts
  // {
  //   id: "c597c300fe3f817c41a2f01d",
  //   author: {
  //     avatar: "/assets/avatars/avatar-iulia-albu.png",
  //     name: "Iulia Albu",
  //   },
  //   category: "Innovation",
  //   cover: "/assets/covers/minimal-1-4x4-large.png",
  //   publishedAt: subDays(
  //     subHours(subMinutes(subSeconds(now, 52), 39), 7),
  //     5
  //   ).getTime(),
  //   readTime: "1 min",
  //   shortDescription:
  //     "Phasellus eu commodo lacus, eget tristique nunc. Ut ullamcorper semper nunc sit amet vehicula.",
  //   title: "Generating Passive Income Is Hard, Here Is a Better Option",
  // },
];

export const postPosts: Post[] = [
  {
    id: "unannounced-meal-detection",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "OSC",
    },
    category: "General",
    cover: "/assets/blogs/unannounced-meal-thinking-40g.jpg",
    publishedAt: new Date("2026-11-04").getTime(),
    readTime: "10 min",
    shortDescription:
      "Unannounced meal detection lets some loops dose insulin without carb entries. See how UAM and SMB work, and when carbless looping is a poor fit.",
    title:
      "Diabetes Without Counting Carbs: How Unannounced Meal Detection Works",
    seoTitle: "Unannounced Meal Detection: Looping Without Counting Carbs",
    path: "/unannounced-meal-detection",
    aliases: ["unannounced-meal-detection"],
    content: unannouncedMealDetection,
  },
  {
    id: "nightscout-database-storage",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    cover:
      "/assets/blogs/nightscout-database-storage/dashboard-database-size.png",
    publishedAt: new Date("2026-06-08").getTime(),
    readTime: "5 min",
    shortDescription: "Clean up your Nightscout database to free up space.",
    title: "How to Check and Clean Your Nightscout Database Storage",
    content: nightscoutDatabaseStorage,
  },
  {
    id: "sex-type-1-and-looping",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Chelsea Okonkwo and Kelvin Kramp (MD, PhD)",
    },
    category: "General",
    cover: "/assets/blogs/sex-type-1-looping-cover-photo.png",
    publishedAt: new Date("2026-10-01").getTime(),
    readTime: "16 min",
    shortDescription:
      "How type 1 diabetes can affect sexual health, and how to manage your pump, CGM, glucose, and alarms so intimacy stays safe and less stressful.",
    title: "Sex, Looping, and Type 1 Diabetes",
    aliases: [
      "Sex and looping",
      "Sex With Type 1 Diabetes - Managing Your Insulin Pump and CGM During Intimacy",
    ],
    content: sexType1Looping,
  },
  {
    id: "hyperglycaemia-in-the-morning",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka and Kelvin Kramp",
    },
    category: "General",
    cover: "/assets/blogs/hyperglycemiamorning/cover.png",
    publishedAt: new Date("2026-03-19").getTime(),
    readTime: "6 min",
    shortDescription:
      "The dawn phenomenon and the Somogyi effect can look the same in the morning, but they need opposite insulin changes. Here is how to tell them apart.",
    title: "Hyperglycaemia in the Morning - Dawn Phenomenon vs Somogyi",
    seoTitle: "Dawn Phenomenon vs Somogyi Effect",
    content: hyperglycaemiaMorning,
  },
  {
    id: "how-to-choose-an-insulin-pump",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Insulin Pump Guide",
    cover:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*GZFncmjyoD443CTal82y4A.png",
    publishedAt: new Date("2025-01-20").getTime(),
    readTime: "11 min",
    shortDescription:
      "Questions to ask before you choose an insulin pump: loop compatibility, CGM pairing, reservoirs, and the daily tasks that matter more than the brand.",
    title: "How to Choose an Insulin Pump",
    content: howToChooseInsulinPump,
  },
  {
    id: "festive-diabetes-management-tips",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "General",
    cover: "/assets/blogs/festive-diabetes-tips.png",
    publishedAt: new Date("2025-12-20").getTime(),
    readTime: "8 min",
    shortDescription:
      "Practical tips to help you navigate Christmas as smoothly as possible.",
    title: "Enjoying Christmas with Type 1 Diabetes",
    content: festiveDiabetesTips,
  },
  {
    id: "10-cgm-test-results-comparison",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/sensorcomparison/sensorpackaging.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "12 min",
    shortDescription:
      "An n=1 comparison of 10 continuous glucose monitoring sensors, focusing on user experience, usability, and integration capabilities for automated insulin delivery systems.",
    title: "Insights from Testing 10 CGMs - How They Stack Up in Daily Use",
    content: cgmTestUsability,
  },
  {
    id: "cgm-test-reliability-accuracy",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/nscomparisonsensors.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "15 min",
    shortDescription:
      "An n=1 comparison of 10 continuous glucose monitoring sensors, focusing on reliability, accuracy, MARD trends, and detailed performance metrics.",
    title:
      "Insights from Testing 10 CGMs - A Comparison in Reliability and Accuracy",
    content: cgmTestReliability,
  },
  {
    id: "cgm-privacy-data-locations",
    author: {
      avatar: "/assets/avatars/LukasTrcka.png",
      name: "Lukáš Trčka",
    },
    category: "Research",
    cover: "/assets/blogs/sensorcomparison/cloudserverdata.png",
    publishedAt: new Date("2026-01-08").getTime(),
    readTime: "8 min",
    shortDescription:
      "A detailed look at where CGM data is stored, privacy policies, and data residency for 10 different continuous glucose monitoring systems.",
    title:
      "Where Does Your Glucose Data Really Go - A Look at CGM Privacy and Server Locations",
    content: cgmTestPrivacy,
  },
  {
    id: "why-we-created-a-cloud-builder",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover: "/assets/blogs/GitHubActions.png",
    publishedAt: new Date("2025-12-18").getTime(),
    readTime: "5 min",
    shortDescription:
      "Automating complexity in open-source diabetes management.",
    title: "Why We Created a Cloud Builder",
    content: cloudbuilder,
  },
  {
    id: "Who-am-I-Corne-Gabriels",
    author: {
      avatar: "/assets/avatars/CG.png",
      name: "Corne Gabriels",
    },
    category: "Community",
    cover: "/assets/avatars/CG.png",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription: "",
    title: "Introducing Corné Gabriels",
    content: whoisCorne,
  },
  {
    id: "Who-am-I-Lukas-Trcka",
    author: {
      avatar: "/assets/avatars/LukasTrcka.jpeg",
      name: "Lukáš Trčka",
    },
    category: "Community",
    cover: "/assets/avatars/LukasTrcka.jpeg",
    publishedAt: new Date("2025-10-14").getTime(),
    readTime: "7 min",
    shortDescription: "",
    title: "Introducing Lukáš Trčka",
    content: whoisLukas,
  },
  {
    id: "Who-am-I-Paul-Banks",
    author: {
      avatar: "/assets/avatars/PaulBanks.png",
      name: "Paul Banks",
    },
    category: "Community",
    cover: "/assets/avatars/PaulBanks.png",
    publishedAt: new Date("2026-03-16").getTime(),
    readTime: "4 min",
    shortDescription: "",
    title: "Introducing Paul Banks",
    content: whoispaul,
  },
  {
    id: "ultrahuman-123456",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "CGM",
    cover: "",
    publishedAt: new Date("2024-01-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "Skip the Hype: Chose a More Affordable Option for Managing Your Glucose",
    title:
      "Why Ultrahuman Is Not the Best Choice for Type 1 Diabetes Management",
    content: ultrahuman,
  },
  {
    id: "Who-am-I-Redmer-Nauta",
    author: {
      avatar: "/assets/avatars/RN.png",
      name: "Redmer Nauta",
    },
    category: "Community",
    cover: "/assets/avatars/RN.png",
    publishedAt: new Date("2025-04-06").getTime(),
    readTime: "5 min",
    shortDescription: "",
    title: "Introducing Redmer Nauta",
    content: whoisredmer,
  },
  {
    id: "no-profile-set-error-fix",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover: "",
    publishedAt: new Date("2024-03-20").getTime(),
    readTime: "3 min",
    shortDescription:
      'A guide to resolving the common "No Profile Set" error in AndroidAPS after updates.',
    title: "How to Fix the No Profile Set Error in AndroidAPS",
    content: noprofileset,
  },
  {
    id: "Bolus-wizard-AndroidAPS-123456",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "AndroidAPS",
    cover: "",
    publishedAt: new Date("2024-01-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "How to use the Bolus Wizard in AndroidAPS to calculate the correct bolus for your meal",
    title: "Bolus Wizard tips in AndroidAPS",
    content: boluswizard,
  },
  {
    id: "24b76cac9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    content: `

<div style="display: flex; justify-content: center;">
<iframe width="560" height="315" src="https://www.youtube.com/embed/6KfsfvLG4T8?si=sbOou9K5l6p4Mh-n" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
</div>

<br />


Nightscout is a powerful tool for monitoring diabetes data in real-time, performing data-analysis over longer time periods, and sharing data with healthcare providers.
However, weak passwords during setup or unauthorized public read access can lead to data breaches, unauthorized data manipulation, and data loss. 
To mitigate these risks, it's crucial to secure your Nightscout site by locking it with a strong password. 
The following steps will guide you through the process of locking your Nightscout account, ensuring your data remains safe and secure.

<br />

## Potential risks of using an unlocked Nightscout

- Unauthorized access to your diabetes data
- Nigthscout downtime due to repeated hacking attempts
- In the worst case, data loss or manipulation


<br />


## How to give reading access to your Nightscout

1. Open your Nightscout site
2. Click the hamburger menu and navigate to "Admin Tools"
3. Enter your API key
4. Click on "Add new subject"
5. Enter the name of the person you want to give reading access
6. In the textfield "Roles" add the word "readable"
7. Click on the "Save" button

You can now click on the access token in the list to get a sharable URL. 

<!-- blog-contact-footer -->

`,
    cover: "",
    publishedAt: new Date("2024-06-10").getTime(),
    readTime: "5 min",
    shortDescription:
      "Learn how to secure your Nightscout site with a password to protect your diabetes data. Follow these steps to ensure your site is safely locked and only accessible for yourself, authorized healthcare professionals, care-takers and family members.",
    title: "How to Create a Reading Access URL to Your Nightscout",
  },
  {
    id: "11b76cac9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Nightscout",
    content: `

<div style="display: flex; justify-content: center;">
<iframe width="560" height="315" src="https://www.youtube.com/embed/GAjUYEij9Ig?si=b5VjQle7ZK4A3YaT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
 </div>


<br />

If you're managing your diabetes with Nightscout, AndroidAPS, and xDrip, you know how important it can be to have a reliable hosting provider for your Nightscout site. There are times when you may want to switch hosting providers, whether due to costs, uptime, features, or simply out of preference. This guide will walk you through the steps to switch your Nightscout URL from one hosting provider to another, while ensuring a smooth transition for your looping setup with AndroidAPS and xDrip.

## **Why You Might Want to Switch Your Hosting Provider**
There are several reasons why you might want to switch your Nightscout hosting provider:
- **Cost:** You might find a more affordable hosting solution that meets your needs.
- **Features:** Some providers offer better performance, speed, or integration options.
- **Reliability:** If your current provider experiences downtimes. We haven't encountered any incidence like this so this seems very rare among the active providers. 

In this guide, we'll go from your current URL https://oldnightscout.oldhostingprovider.com to your new URL https://newnightscout.newhostingprovider.com


<br/>

# Step 1 Upload glucosedata from xDrip+ to Nightscout
## 1.1 Verify Your New Site
Before making any changes to your AndroidAPS or xDrip settings, ensure that your new Nightscout URL is reachable. You don't have to setup anything yet such a new default profile. Just check if the site is reachable and that you see no errors. 

## 1.2 Update xDrip Settings**

xDrip uploads and downloads data from your Nightscout site, so you need to update it with the new URL.

1. Open **xDrip+** on your phone.
2. Go to **Settings > Cloud Upload**.
3. Select **Nightscout Sync (REST-API)** 
4. Select **BASE URL** and change the URL to https://password@newnightscout.newhostingprovider.com.
5. Replace password with the **API_SECRET** of your new Nightscout and click **OK**.
6. Set the top option "Enable: The REST API is .." to **ON**.
7. Go to **Extra Options** and set select **Back-fill data**.
8. Click **Select the period you want to upload to NigthScout** and click ** DO IT!**. There is a warning that says "Use with care". This warning is there because if you don't use the right API_SECRET, the upload 
will be considered an attack and your Nightscout will be blocked for upload request for several houres to days. So indeed, be carefull with this option.


You should see that xDrip is now uploading data from your new Nightscout URL. 

<br/>

# Step 2: Temporarily switch to old Nightscout version within AndroidAPS

Temporary switch to the old Nightscout version within AndroidAPS will make it possible to upload your data from AndroidAPS without setting a new profile and API_SECRET in the admin page. 

1. Open **AndroidAPS** on your phone.
2. Go to hamburgmenu in left top and select **Config Builder**.
3. Scroll to **Synchronisation** and select NSClient instead of NSClientV3. 
4. Click on the cogwheel on the right to go to the preferences of the NSClient.
4. Change the **Nightscout URL** to https://newnightscout.newhostingprovider.com
5. Enter your **API_SECRET** for the new Nightscout instance.
6. Go to the home screen and go to the tab NSCLIENT.
7. Check whether **Status: Authenticated** is shown at the top left! If not, check your API_SECRET and URL.

<br/>

# Step 3: Upload data from AndroidAPS to new Nightscout

1. Go back to the home screen and click on the three dots.
2. Choose full-synchronisation and follow the steps. This will upload your profiles to the new Nightscout instance and remove the prompt to setup a new profile we saw in step 1.


xDrip+ and AndroidAPS are now setup to upload data to your new Nightscout. 

<br/>


Once you've confirmed that your new Nightscout instance is working perfectly, you can cancel your old hosting provider subscription. 
Make sure to monitor your new setup for a few days and keep your old hosting provider active until you're confident everything is functioning correctly! 
If you run into issues, don't hesitate to reach out to the Nightscout, AndroidAPS, xDrip communities. You can find their Facebook pages in our [CommunityApps section](/diabetesmanagementapps).

<!-- blog-contact-footer -->

`,
    cover: "",
    publishedAt: new Date("2024-06-10").getTime(),
    readTime: "5 min",
    shortDescription:
      "Considering switching your Nightscout provider? Here's how to do it",
    title:
      "How to Switch Your Nightscout URL to a New Hosting Provider When Looping with AndroidAPS and xDrip",
  },
  {
    id: "Who-am-I-Hylke-Nicola",
    author: {
      avatar: "/asset s/avatars/HN.png",
      name: "Hylke Nicola",
    },
    category: "Community",
    cover: "/assets/avatars/HN.png",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription: "",
    title: "Introducing Hylke Nicola",
    content: whoishylke,
  },
  {
    id: "Who-am-I-Kelvin-Kramp",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Community",
    content: whoiskelvin,
    cover: "/assets/avatars/KK.jpeg",
    publishedAt: new Date("2025-04-07").getTime(),
    readTime: "5 min",
    shortDescription: "",
    title: "Introducing Kelvin Kramp",
  },
  {
    id: "00b76cac9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Research",
    content: `

<div style="display: flex; justify-content: center;">
<image src="https://cdn-images-1.medium.com/max/2000/1*m6S5sxMH2__fiTTbns7gAA.png"/>
</div>
</br>

Open Humans has a <a href="https://www.openhumans.org/api/public/datatypes/" target="_blank">list of projects</a>
 you can access via the public API. A project is defined as a person or researcher that has shared their data. 
 
You can find more details about every specific project via this page:
[https://www.openhumans.org/explore-share/](https://www.openhumans.org/explore-share/)

 In the case of Nightscout, a real-time diabetes monitoring tool, users can upload their data via the Open Humans synchronization tool in their artificial pancreas app AndroidAPS.

 <div style="display: flex; justify-content: center;">
<image src="https://miro.medium.com/v2/resize:fit:720/format:webp/1*u-J9V6bsx_Qq3ZwYiYUlRg.png"/>
</div>
</br>



You can get the data of a specific project by following the below steps.

<br/>

## A. Install Python

#### Windows

 1. Go to the [Python website](https://www.python.org/).

 2. Download the latest Python installer for Windows.

 3. Run the installer and check "Add Python to PATH".

 4. Click "Install Now".

#### Mac

 1. Go to the [Python website](https://www.python.org/).

 2. Download the latest Python installer for macOS.

 3. Open the downloaded .pkg file.

 4. Follow the on-screen instructions to complete the installation

## B. Open terminal

#### Windows

 1. Press Windows + R to open the Run dialog.

 2. Type cmd and press Enter.

#### Mac

 1. Press Command + Space to open Spotlight Search.

 2. Type Terminal and press Enter.

## C. Create virtual environment

#### Windows

    cd projectpath && python -m venv env && .\\env\\Scripts\\activate"
    

#### Mac

    cd path/to/your/project && python3 -m venv env && source env/bin/activate

## D. Install Open Humans module

    pip install open-humans-api

## E. Find the project code of a project

For instance the code for the first source project in the project with id 3 and name "Genetic Data" is "1989"

<div style="display: flex; justify-content: center;">
<image src="https://cdn-images-1.medium.com/max/4156/1*NzEB_HQ6RV9mGJsPHmHhHA.png" height="500px"/>
</div>

## F. Run the downloader

Make a directory and run the open humans downloader. Replace 1989 with the project code.

    mkdir directoryname

    ohpub-download --source direct-sharing-1989 --directory directoryname

<!-- blog-contact-footer -->
    `,
    cover: "",
    publishedAt: new Date("2024-05-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "Open Humans, a platform that allows individuals to share personal data and provides a public API.",
    title: "Get Nightscout Research Data From Open Humans",
  },
  {
    id: "00b76cac9a128cd949741010",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "CGM",
    content: blog3,
    cover: "",
    publishedAt: new Date("2024-05-01").getTime(),
    readTime: "15 min",
    shortDescription:
      "A step-by-step instructions to help you monitor your glucose levels in real-time with a Freestyle Libre 2.",
    title: "Setup Your FreeStyle Libre 2 As A Continuous Glucose Monitor",
  },
  {
    id: "00111cac9a128cd949741010",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Research",
    content: blog4,
    cover: "/assets/blogs/whitepaper.png",
    publishedAt: new Date("2024-05-21").getTime(),
    readTime: "15 min",
    shortDescription:
      "Universal access to advanced, user-friendly open sourcer diabetes management technology through collaborative open-source development involving PWD, healthcare professionals, and IT experts, to overcome existing economic, geographical, and educational barriers.",
    title: "White Paper: Open-Source Looping",
  },
  // {
  //   id: "lyumjev-pump-guide-123456",
  //   author: {
  //     avatar: "/assets/avatars/author-avatar.png",
  //     name: "Your Name",
  //   },
  //   category: "Insulin Pump Guide",
  //   content: blog7,
  //   cover: "",
  //   publishedAt: new Date("2024-10-11").getTime(),
  //   readTime: "5 min",
  //   shortDescription:
  //     "Filling your insulin pump cartridge with Lyumjev can seem daunting at first, but with the right steps, it becomes a quick and easy process.",
  //   title: "How to Fill Your Insulin Pump Cartridge with Lyumjev",
  // },
  {
    id: "protein-hidden-impact",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    category: "Research",
    cover: "/assets/blogs/proteinimpact.png",
    publishedAt: new Date("2024-03-21").getTime(),
    readTime: "15 min",
    shortDescription:
      "How protein raises glucose later than carbohydrates, and what that means for boluses and open-source loop settings.",
    title: "Protein's Hidden Impact on Blood Glucose",
    content: proteinhiddenimpace,
  },
  // removed manifesto from detailed posts
];

export const privacyPosts: Post[] = [
  {
    id: "14b76abc9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    cover: "/assets/covers/NEN7510_wide.png",
    publishedAt: new Date("2024-06-10").getTime(),
    shortDescription: "CommitedDescription",
    title: "NEN 7510 Certification",
  },
  {
    id: "20b76abd9a128cd949747080",
    author: {
      avatar: "/assets/avatars/kelvinkramp.png",
      name: "Kelvin Kramp",
    },
    cover: "/assets/covers/confidentiality.jpeg",
    publishedAt: new Date("2024-05-01").getTime(),
    shortDescription: "DiscretionConfidentialityDescription",
    title: "DiscretionConfidentiality",
  },
  {
    id: "30b76abd9a128cd949741010",
    author: {
      avatar: "/assets/covers/Nightscout_wide.png",
      name: "Kelvin Kramp",
    },
    cover: "/assets/covers/test2.png",
    publishedAt: new Date("2021-05-15").getTime(),
    shortDescription: "SaveDataSharingDescription",
    title: "SaveDataSharing",
  },
];
